var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-status-tag tag",class:{
        'is-success': _vm.device.status && _vm.device.status === 'online',
        'is-danger': _vm.device.status && _vm.device.status === 'offline',
        'is-warning': _vm.device.status === 'pending' || _vm.device.status === null,
       }},[_vm._v(" "+_vm._s(_vm.device.status ? _vm.device.status.toUpperCase() : 'PENDING')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }